<template>
  <CompaniesTable
    feature="similar"
    has-selection
    :scroll-top-on-page-change="false"
    view="similar"
    wrapper-classes="min-h-[620px]"
  >
    <template #header="{ companies, count }">
      <SegmentationHorizontal
        :companies="companies"
        feature="similar"
        :has-actions="false"
        :query-count="count"
      />
    </template>
  </CompaniesTable>
</template>
